import React, { memo } from 'react';
import { Text, Button, Spacer } from '@Sage/hoi-poi-ui';

import { getLiteral } from 'utils/getLiteral';

import ProductUnitRelationsEmptyIllustration from './ProductUnitRelationsEmptyIllustration';

/** Empty state for product UoM relations; `emptyViewProps.onClick` opens the add modal. */
const ProductUnitRelationsEmpty = memo(({ emptyViewProps }) => {
    const onClick = emptyViewProps?.onClick;
    return (
        <div className="product-unit-relations-empty">
            <ProductUnitRelationsEmptyIllustration className="product-unit-relations-empty__illustration" />
            <Spacer y={3} />
            <Text type="body1">{getLiteral('title_add_unit_relation')}</Text>
            <Spacer y={1} />
            <Text type="caption">{getLiteral('title_add_unit_relation_desc')}</Text>
            <Spacer y={3} />
            <Button type="secondary" onClick={onClick} isDisabled={typeof onClick !== 'function'}>
                {getLiteral('action_add_unit')}
            </Button>
        </div>
    );
});

ProductUnitRelationsEmpty.displayName = 'ProductUnitRelationsEmpty';

export default ProductUnitRelationsEmpty;
